var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "tap",
          rawName: "v-tap",
          value: (e) => _vm.BtnClick(),
          expression: "(e) => BtnClick()",
        },
      ],
      attrs: { align: "left" },
    },
    [
      _c(
        "v-tooltip",
        {
          attrs: { bottom: "", color: "primary" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on }) {
                return [
                  _c(
                    "v-btn",
                    _vm._g({ attrs: { icon: "" } }, on),
                    [
                      _c(
                        "v-icon",
                        { attrs: { color: _vm.color, "x-large": "" } },
                        [_vm._v(_vm._s(_vm.icon))]
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [
          _vm.toolTip === "" || _vm.toolTip === null
            ? _c("span", [_vm._v(_vm._s(_vm.$t("back")))])
            : _c("span", [_vm._v(_vm._s(_vm.$t(_vm.toolTip)))]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }